export default __webpack_public_path__ + "static/media/villa_7.91ff4eb3.jpg";